import { j as r } from "./atoms-v218.js";
import { InputContainer as a } from "./atoms-v219.js";
const e = ({ children: t, className: n, variant: o = "productive" }) => /* @__PURE__ */ r.jsx(a, { $variant: o, className: `input-container ${n}`, children: t });
export {
  e as InputContainer
};
